import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-notPaid",
  "use": "icon-notPaid-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-notPaid\"><path d=\"M993.391 0H30.61C13.705 0 0 13 0 29.04v965.915C0 1010.995 13.705 1024 30.61 1024h962.78c16.904 0 30.609-13.005 30.609-29.045V29.04C1024 13 1010.295 0 993.391 0zM972.8 633.18H738.995c-84.83 0-153.6-68.77-153.6-153.6s68.77-153.6 153.6-153.6H972.8v307.2z m0-358.4H737.495c-112.28 0-203.3 91.69-203.3 204.8 0 113.11 91.02 204.8 203.3 204.8H972.8V947.2c0 14.14-11.46 25.6-25.6 25.6H76.8c-14.135 0-25.6-11.46-25.6-25.6V76.8c0-14.14 11.465-25.6 25.6-25.6h870.4c14.14 0 25.6 11.46 25.6 25.6v197.98z m-209.279 158.5c-28.275 0-51.2 22.92-51.2 51.2 0 28.279 22.925 51.199 51.2 51.199 28.274 0 51.199-22.92 51.199-51.199 0-28.28-22.925-51.2-51.199-51.2z m0 53.76a2.56 2.56 0 1 1 0-5.121c1.415 0 2.56 1.146 2.56 2.561s-1.145 2.56-2.56 2.56z\" p-id=\"627\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/notPaid.svg
// module id = YQ8W
// module chunks = 51